// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"788e5d52","57":"616116ab","587":"5877fd39","632":"4c73d253","698":"167ffd86","908":"6ad73a07","912":"73d5e07e","970":"65719889"}[chunkId] + ".chunk.js";
};